import Config from "./Config";

class Navbar
{

    /**
     * @param {Logger} logger
     * @param {EventDispatcher} eventDispatcher
     * @param {BrowserController} browserController
     * @param options
     */
    constructor(logger, eventDispatcher, browserController, options) {
        this._config = new Config(
            {
                id: 'mainNavbar',
                transparent: false
            },
            options
        );
        this._logger = logger;
        this._ed = eventDispatcher;
        this._bc = browserController;
        this.isTransparent = false;
        this.isCollapsedShown = false;
        this.isTransparentZone = this._isTransparentZone(this._bc.getScroll().y);
        this.canBeTransparent = this._config.get('transparent');
        this.isMobileFormat = this._isMobileFormat(
            this._bc.getWindowSize().width
        );
        this.element = this._bc.documentQuerySelector('#' + this._config.get('id'));
        this._onShownCollapsed = this._onShownCollapsed.bind(this);
        this._onHiddenCollapsed = this._onHiddenCollapsed.bind(this);
        this._bind();
        this._onChange();
    }

    _bind()
    {
        this._bc.documentQuerySelector('#navbarCollapsableContent').addEventListener(
            'shown.bs.collapse',
            this._onShownCollapsed
        );
        this._bc.documentQuerySelector('#navbarCollapsableContent').addEventListener(
            'hidden.bs.collapse',
            this._onHiddenCollapsed
        );
        this._ed.on(
            'wnd.scrolled',
            this._onScroll,
            this
        )
        this._ed.on(
            'wnd.resized',
            this._onResize,
            this
        );
    }

    hideBg()
    {
        if (!this.isTransparent) {
            this.element.classList.remove("bg-header-gradient");
            this.element.classList.add("bg-header-no");
            this.isTransparent = true;
        }
    }

    showBg()
    {
        if (this.isTransparent) {
            this.element.classList.remove("bg-header-no");
            this.element.classList.add("bg-header-gradient");
            this.isTransparent = false;
        }
    }

    _onShownCollapsed()
    {
        if (!this.isCollapsedShown) {
            this.isCollapsedShown = true;
            this._onChange();
        }
    }

    _onHiddenCollapsed()
    {
        if (this.isCollapsedShown) {
            this.isCollapsedShown = false;
            this._onChange();
        }
    }

    _isTransparentZone(scrollY)
    {
        return scrollY <= 15;
    }

    _onScroll(data)
    {
        let isTransparentZone = this._isTransparentZone(data.new.y);
        if (isTransparentZone !== this.isTransparentZone) {
            this.isTransparentZone = isTransparentZone;
            this._onChange();
        }
    }

    _isMobileFormat(width)
    {
        return width < 768;
    }

    _onResize(data)
    {
        let isMobileFormat = this._isMobileFormat(data.new.window.width);
        if (this.isMobileFormat !== isMobileFormat) {
            this.isMobileFormat = isMobileFormat;
            this._onChange();
        }
    }

    _onChange()
    {
        let mobileFormatCollapsedShown = this.isMobileFormat && this.isCollapsedShown;
        let transparent = this.canBeTransparent && this.isTransparentZone && !mobileFormatCollapsedShown;
        this._logger.debug('Change transparent to ' + (transparent ? 'YES' : 'NO'));
        if (transparent && !this.isTransparent) {
            this.hideBg();
        } else if (!transparent && this.isTransparent) {
            this.showBg();
        }
    }


}

export default Navbar;